import moduleRegistry from '../module-registry/module-registry';

// tabindex 0 wenn 
const config = {
    selectors: {
        root: '.sticky-section',
        stickyBar: '.sticky-section__bar',
        stickyBarItems: '.sticky-section__bar-items',
        stickyBarItem: '.sticky-section__bar-item',
        stickySectionContent: '.sticky-section__content',
        stickySectionContentWrapper: '.sticky-section__content-wrapper',
        stickyBarItemsWrapper: '.sticky-section__bar-items-wrapper',
        arrowLeft: '.sticky-section__bar-arrow-left',
        arrowRight: '.sticky-section__bar-arrow-right'
    },
    classNames: {
        stickyBarItemActive: 'sticky-section__bar-item--active',
        stickySectionContentVisible: 'sticky-section__content--visible',
        stickySectionBarSticky: 'sticky-section__bar--sticky',
        stickyBarUp: 'sticky-section__bar--up',
        stickyBarDown: 'sticky-section__bar--down',
        stickyBarTransition: 'sticky-section__bar--transition',
        arrowLeftVisible: 'sticky-section__bar-arrow-left--visible',
        arrowRightVisible: 'sticky-section__bar-arrow-right--visible',
        stickyBarItemsWrapperRight: 'sticky-section__bar-items-wrapper--right',

    },
    dataAttributes: {
        stickySectionId: 'sticky-section-id',
        stickySectionTitle: 'sticky-section-title',
        smartedit: 'smartedit',

    }
};

export class StickySection {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._initialStickyBarTop = 0;
        this._canChangeState = true;
        this._lastWindowTop = 0;
        this._isSticky = false;
        this._enabledArrows = false;
        this._currentIndex = 0;
        this._currentTranslateX = 0;
        this._touchStart = 0;
        this._delta = 0;
        this._counter = 0
    }

    static _canBecomeSticky = true;

    init() {
        this._elements = this._getDomElements();
        this._elements.$stickyBarItems.html(this._createStickyBarItemHtml());

        const smartedit = $('body').data(config.dataAttributes.smartedit);

        if (smartedit === true || smartedit === 'true') {
            StickySection._canBecomeSticky = false;
        }

        // append dynamic content to elements
        this._elements.$stickyBarItem = this._$rootElement.find(config.selectors.stickyBarItem);

        this._initialStickyBarTop = this._elements.$stickyBar.offset().top;
        this._lastWindowTop = $(window).scrollTop();
        this._addEventListeners();
        this.checkSticky();

        // this._elements.$stickySectionContent.each((i,item) => {
        //     const $item = $(item);

        //     if(i !== 0) {
        //         $item.height(0);
        //     }
        // });
        
        if (this._elements.$stickyBarItems.width() + 30 > $(document).width() || this._elements.$stickyBarItems.width() > 1270) {
            this._enableArrows();
            this._enabledArrows = true;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const section = urlParams.get('section');
        const _this = this;

        if (section) {
            _this._elements.$stickyBarItem.removeClass(config.classNames.stickyBarItemActive);
            _this._elements.$stickySectionContent.removeClass(config.classNames.stickySectionContentVisible);

            if (!_this._$rootElement.hasClass('sticky-section--was-clicked')) {
                _this._$rootElement.addClass('sticky-section--was-clicked');
            }

            const $section = _this._$rootElement.find(`.sticky-section__content[data-sticky-section-id="${section}"]`);
            const $item = _this._$rootElement.find(`.sticky-section__bar-item[data-sticky-section-id="${section}"]`);
            const child = _this._findFirstColoredChild($section[0]);

            $item.addClass(config.classNames.stickyBarItemActive);



            if (smartedit !== true && smartedit !== 'true') {
                _this._elements.$stickySectionContentWrapper.css('background-color', $(child).css('background-color'));
            }

            let number = 0;

            if (_this._enabledArrows) {
                let index = 0;
                _this._elements.$stickyBar.find(config.selectors.stickyBarItem).each((i, el) => {
                    if (el === $item[0]) {
                        index = i;
                    }

                    if (index === 0) {
                        if (i === 0) {
                            number += $(el).width() + 19.95;
                        } else {
                            number += $(el).width() + 19.95;
                        }
                    }
                });

                // special cases
                if (index === 0) {
                    const containerWidth = _this._$rootElement.find('.sticky-section__bar-container').width();
                    const max = _this._elements.$stickyBarItems.width() - containerWidth;

                    _this._elements.$stickyBarItemsWrapper.css("transform", "translate(" + (max) + "px)");
                    _this._currentTranslateX = max;
                } else if (index === _this._elements.$stickyBar.find(config.selectors.stickyBarItem).length - 1) {
                    _this._elements.$stickyBarItemsWrapper.css("transform", "translate(" + (0) + "px)");
                    _this._currentTranslateX = 0;
                } else {
                    // default case
                    const containerWidth = _this._$rootElement.find('.sticky-section__bar-container').width();
                    const max = _this._elements.$stickyBarItems.width() - containerWidth;
                    number = _this._elements.$stickyBarItemsWrapper.width() - number - containerWidth;
                    number += 30;
                    const activeElementWidth = $(_this._elements.$stickyBar.find(config.selectors.stickyBarItem)[index]).width() + 19.95;
                    const previousElementWidth = $(_this._elements.$stickyBar.find(config.selectors.stickyBarItem)[index - 1]).width() + 19.95;

                    if (containerWidth > activeElementWidth + previousElementWidth) {
                        number += previousElementWidth;
                    }

                    if (number > max) {
                        number = max;
                    }

                    if (number < 0) {
                        _this._elements.$stickyBarItemsWrapper.css("transform", "translate(" + (0) + "px)");
                        _this._currentTranslateX = 0;
                    } else {
                        _this._elements.$stickyBarItemsWrapper.css("transform", "translate(" + (number) + "px)");
                        _this._currentTranslateX = number;
                    }
                }

                _this._updateArrows();
            }



            setTimeout(() => {
                _this._elements.$stickySectionContent.height(0);
                $section.height($section[0].scrollHeight);

                if (!(smartedit === true || smartedit === 'true')) {
                    window.scrollTo({
                        top: $item.closest('.sticky-section')[0].offsetTop - $item.closest('.sticky-section__bar')[0].getBoundingClientRect().height + 150,
                        left: 0,
                        behavior: "smooth",
                    });
                }

                _this._becomeSticky();

                setTimeout(() => {
                    $section.addClass(config.classNames.stickySectionContentVisible);
                }, 5);
            }, 650);
        }
    }

    _getDomElements() {
        return {
            $stickyBar: this._$rootElement.find(config.selectors.stickyBar),
            $stickyBarItems: this._$rootElement.find(config.selectors.stickyBarItems),
            $stickyBarItem: null,
            $stickySectionContent: this._$rootElement.find(config.selectors.stickySectionContent),
            $stickySectionContentWrapper: this._$rootElement.find(config.selectors.stickySectionContentWrapper),
            $stickyBarItemsWrapper: this._$rootElement.find(config.selectors.stickyBarItemsWrapper),
            $arrowLeft: this._$rootElement.find(config.selectors.arrowLeft),
            $arrowRight: this._$rootElement.find(config.selectors.arrowRight),
        };
    }

    _addEventListeners() {
        const _this = this;
        let counter = 0
        _this._elements.$arrowLeft.on('click', () => {
            _this._onLeftArrowClick();
        });

        _this._elements.$arrowRight.on('click', () => {
            _this._onRightArrowClick();
        });

        _this._elements.$stickyBar.find(config.selectors.stickyBarItem).on('click', function (e) {
            _this._changeTab(e.target)
        });

        _this._elements.$stickyBar.find(config.selectors.stickyBarItem).keyup(function (e) {
            
            if ((e.keyCode == 13)) {
                _this._changeTab(e.target, 'keyboard')
            }

            if ((e.keyCode == 9)) {
                ++counter;
                const barItemSpan = $(_this._$rootElement.find(config.selectors.stickyBarItem + ' span'));
                $(barItemSpan).attr('tabindex', '0')
                if (counter === _this._elements.$stickyBar.find(config.selectors.stickyBarItem).length - 1 && (_this._elements.$stickyBarItems.width() + 30 > $(document).width() || _this._elements.$stickyBarItems.width() > 1270)) {
                    _this._elements.$arrowLeft.addClass(config.classNames.arrowLeftVisible);
                    _this._elements.$arrowRight.removeClass(config.classNames.arrowRightVisible);
                }
            }
        });

        const stickybarItems = _this._elements.$stickyBar.find(config.selectors.stickyBarItem)
      
            $( stickybarItems[stickybarItems.length-1]).keyup(function (e) {
                if ((e.code == 'Enter')) {
                    _this._changeTab(e.target, 'keyboard')
                }
    
                if ((e.code == 'Tab')) {
                    $(config.selectors.stickySectionContent + ' a').attr('tabindex','-1')
                    $(config.selectors.stickySectionContent + ' .card-tiles__tiles button').attr('tabindex','-1')
                    $(config.selectors.stickySectionContent + ' .product-card__cta button').attr('tabindex','-1')
                    $(config.selectors.stickySectionContent + ' .drag-bar__control-btn').attr('tabindex','-1')
                    $(config.selectors.stickySectionContent + ' .drag-bar__bar-item').attr('tabindex','-1')
                    $(config.selectors.stickySectionContent + ' .image-slider__dot').attr('tabindex','-1')  
                }
           
            });

        var dwidth = $(window).width();

        $(window).on('resize', () => {
            var wwidth = $(window).width();
            if (dwidth !== wwidth) {
                this._lastWindowTop = $(window).scrollTop();
                if (this._elements.$stickyBarItems.width() + 30 > $(document).width() || this._elements.$stickyBarItems.width() > 1270) {
                    if (!this._enabledArrows) {
                        this._enableArrows();
                        this._enabledArrows = true;
                    } else {
                        this._onLeftArrowClick();
                        this._enabledArrows = true;
                    }
                } else {
                    if (this._enabledArrows) {
                        this._disableArrows();
                        this._enabledArrows = false;
                    }
                }
            }
        });


        $(window).on('scroll', () => {
            const elementTop = this._elements.$stickyBar.offset().top;
            const elementHeight = this._elements.$stickyBar.height();
            const elementBottom = elementTop + elementHeight;

            const $activeContent = this._$rootElement.find(`.${config.classNames.stickySectionContentVisible}`);
            const contentTop = this._$rootElement.offset().top;
            const contentBottom = contentTop + this._$rootElement.height();

            const windowTop = $(window).scrollTop();
            const topDifference = elementTop - contentTop;
            // console.log(contentTop);


            // scroll bottom
            if (this._lastWindowTop < windowTop) {
                $(_this._elements.$stickyBar).removeClass(config.classNames.stickyBarTransition)
                $(_this._elements.$stickyBar).removeClass(config.classNames.stickyBarUp);

                if (windowTop >= elementTop && !(windowTop >= elementBottom) && !(elementBottom >= contentBottom)) {
                    this._becomeSticky();
                    // console.log('sticky');
                }

                if (windowTop > contentBottom && this._isSticky) {

                    this._becomeUnsticky(windowTop - contentTop);
                }
            }

            // scroll top
            else if (this._lastWindowTop > windowTop) {
                if ($(_this._elements.$stickyBar).hasClass(config.classNames.stickySectionBarSticky)) {

                    $(_this._elements.$stickyBar).addClass(config.classNames.stickyBarUp)
                    $(_this._elements.$stickyBar).addClass(config.classNames.stickyBarTransition)
                } else {
                    $(_this._elements.$stickyBar).removeClass(config.classNames.stickyBarUp)
                }


                if (windowTop < elementTop && elementTop > contentTop) {


                    this._becomeSticky();

                }



                if ((windowTop + 110) <= contentTop) {

                    this._becomeUnsticky(0);
                }
            }

            this._lastWindowTop = windowTop;
        });

        this._elements.$stickyBarItemsWrapper.on('dragstart', () => {

        });

        this._elements.$stickyBarItemsWrapper.on('dragend', () => {

        });

        // track touchstart and delta positions
        this._elements.$stickyBarItemsWrapper.on('touchmove', (e) => {
            const position = (e.changedTouches[0].clientX - window.innerWidth / 2) * 0.5;

            if (this._touchStart === 0) {
                this._touchStart = position
            }

            this._delta = position;
        });

        // trigger function depending on resulting positions & reset positions after
        this._elements.$stickyBarItemsWrapper.on("touchend", () => {
            if (this._enabledArrows) {
                if (this._delta - this._touchStart > 0) {
                    _this._onLeftArrowClick();
                } else {
                    _this._onRightArrowClick();
                }

                this._touchStart = 0;
            }

        });
    }


    _changeTab(item, control = '') {

        const _this = this;
        const smartedit = $('body').data(config.dataAttributes.smartedit);
        _this._counter = $(item).data('index');
   
        if (!_this._$rootElement.hasClass('sticky-section--was-clicked')) {
            _this._$rootElement.addClass('sticky-section--was-clicked');
            const el = _this._elements.$stickySectionContent[0];
            $(el).height(el.scrollHeight);
        }

        let $el = _this._proofClass(item);

        const id = $el.data(config.dataAttributes.stickySectionId);

        _this._updateUrl(id);


        if (!(smartedit === true || smartedit === 'true')) {
            window.scrollTo({
                top: $el.closest('.sticky-section')[0].offsetTop - $el.closest('.sticky-section__bar')[0].getBoundingClientRect().height,
                left: 0,
                behavior: "smooth",
            });
        }


        _this._elements.$stickyBarItem.removeClass(config.classNames.stickyBarItemActive);
        $el.addClass(config.classNames.stickyBarItemActive);

        _this._elements.$stickySectionContent.removeClass(config.classNames.stickySectionContentVisible);

        const $section = _this._$rootElement.find(`.sticky-section__content[data-sticky-section-id="${id}"]`);

        const child = _this._findFirstColoredChild($section[0]);

        if (smartedit !== true && smartedit !== 'true') {
            _this._elements.$stickySectionContentWrapper.css('background-color', $(child).css('background-color'));
        }

        let number = 0;

        if (_this._enabledArrows) {
            let index = 0;
            _this._elements.$stickyBar.find(config.selectors.stickyBarItem).each((i, el) => {
                if (el === this) {
                    index = i;
                }

                if (index === 0) {
                    if (i === 0) {
                        number += $(el).width() + 19.95;
                    } else {
                        number += $(el).width() + 19.95;
                    }
                }
            });

            // special cases
            if (index === 0) {
                const containerWidth = _this._$rootElement.find('.sticky-section__bar-container').width();
                const max = _this._elements.$stickyBarItems.width() - containerWidth;

                _this._elements.$stickyBarItemsWrapper.css("transform", "translate(" + (max) + "px)");
                _this._currentTranslateX = max;

            } else if (index === _this._elements.$stickyBar.find(config.selectors.stickyBarItem).length - 1) {
                _this._elements.$stickyBarItemsWrapper.css("transform", "translate(" + (0) + "px)");
                _this._currentTranslateX = 0;
            } else {
                // default case
                const containerWidth = _this._$rootElement.find('.sticky-section__bar-container').width();
                const max = _this._elements.$stickyBarItems.width() - containerWidth;
                number = _this._elements.$stickyBarItemsWrapper.width() - number - containerWidth;
                number += 30;
                const activeElementWidth = $(_this._elements.$stickyBar.find(config.selectors.stickyBarItem)[index]).width() + 19.95;
                const previousElementWidth = $(_this._elements.$stickyBar.find(config.selectors.stickyBarItem)[index - 1]).width() + 19.95;

                if (containerWidth > activeElementWidth + previousElementWidth) {
                    number += previousElementWidth;
                }

                if (number > max) {
                    number = max;
                }

                if (number < 0) {
                    _this._elements.$stickyBarItemsWrapper.css("transform", "translate(" + (0) + "px)");
                    _this._currentTranslateX = 0;
                } else {
                    _this._elements.$stickyBarItemsWrapper.css("transform", "translate(" + (number) + "px)");
                    _this._currentTranslateX = number;
                }
            }

            _this._updateArrows();
        }

        if (control === 'keyboard') {
           $(config.selectors.stickyBarItem + ' span').attr('tabindex','-1')
            $(config.selectors.stickySectionContent + ' a').attr('tabindex','-1')
            $(config.selectors.stickySectionContent + ' .card-tiles__tiles button').attr('tabindex','-1')
            $(config.selectors.stickySectionContent + ' .product-card__cta button').attr('tabindex','-1')
            $(config.selectors.stickySectionContent + ' .drag-bar__control-btn').attr('tabindex','-1')
            $(config.selectors.stickySectionContent + ' .drag-bar__bar-item').attr('tabindex','-1')
            $(config.selectors.stickySectionContent + ' .image-slider__dot').attr('tabindex','-1')
            
            $section.find('a').attr('tabindex','0')
           
            $section.find('.product-card__cta button').attr('tabindex','0')
            $section.find('.drag-bar__control-btn').attr('tabindex','0')
            $section.find('.drag-bar__bar-item').attr('tabindex','0')
            $section.find('.image-slider__dot').attr('tabindex','0')
            const linksInnerSection =  $section.find('a');
            const newFocusedItem = $(_this._$rootElement.find(config.selectors.stickyBarItem)[_this._counter + 1]).children();
            $(newFocusedItem).attr('tabindex', '-1')
        
        
            let keypressed = {};
            linksInnerSection[0].addEventListener('keydown', function (event) {
                //set keycode in object for better tracking
                keypressed[event.code] = true;
               //proof if schift+tab ist pressed
                if(keypressed['ShiftLeft']  && keypressed['Tab']){
                   $(item).attr('tabindex', '0')
                }
               

            })
           //reset keycode in object for better tracking
           linksInnerSection[0].addEventListener('keyup', function (event) {
                keypressed[event.code] = false;
            })
        
            linksInnerSection[linksInnerSection.length -1].addEventListener('keydown', function (event) {
                let allSpansClosestSticky= $(item).closest(config.selectors.stickyBarItem).siblings()
               
                if((allSpansClosestSticky.length != _this._counter) && event.code == 'Tab') {
                    event.preventDefault();
                    $(newFocusedItem[0]).attr('tabindex', '0')
                    $(newFocusedItem[0]).trigger("focus");
                }
            })
        }



        setTimeout(() => {
            _this._elements.$stickySectionContent.height(0);
            $section.height($section[0].scrollHeight);


            setTimeout(() => {
                $section.addClass(config.classNames.stickySectionContentVisible);
            }, 5);
        }, 650);
    }

    _proofClass(item) {
        if ($(item).hasClass('sticky-section__bar-item')) {
            return $(item)
        } else {
            return $(item.parentNode)
        }
    }

    _enableArrows() {
        let left = $(document).width() - 30;

        if (left > 1270) {
            left = 1270;
        }

        this._currentTranslateX = this._elements.$stickyBarItems.width() - left;

        this._elements.$arrowLeft.removeClass(config.classNames.arrowLeftVisible);
        this._elements.$arrowRight.addClass(config.classNames.arrowRightVisible);
        this._elements.$stickyBarItemsWrapper.addClass(config.classNames.stickyBarItemsWrapperRight);
        this._elements.$stickyBarItemsWrapper.css("transform", "translate(" + ((this._currentTranslateX)) + "px)");
    }

    _disableArrows() {
        this._currentTranslateX = 0;
        this._elements.$arrowLeft.removeClass(config.classNames.arrowLeftVisible);
        this._elements.$arrowRight.removeClass(config.classNames.arrowRightVisible);
        this._elements.$stickyBarItemsWrapper.removeClass(config.classNames.stickyBarItemsWrapperRight);
        this._elements.$stickyBarItemsWrapper.css("transform", "translate(0px)");
    }

    _onLeftArrowClick() {


        let left = $(document).width() - 30;

        if (left > 1270) {
            left = 1270;
        }

        this._currentTranslateX += $(document).width() / 2 - 30;

        const max = this._elements.$stickyBarItems.width() - left;

        if (this._currentTranslateX > max) {
            this._currentTranslateX = max;
        }


        this._elements.$stickyBarItemsWrapper.css("transform", "translate(" + ((this._currentTranslateX)) + "px)");
        this._updateArrows();
    }

    _onRightArrowClick() {
        let left = $(document).width() + 30;

        if (left > 1270) {
            left = 1270;
        }

        const max = this._elements.$stickyBarItems.width() - left;

        if (this._elements.$stickyBarItems.width() > $(document).width() * 2) {
            this._currentTranslateX -= $(document).width() / 2 + 30;

            if (this._currentTranslateX < 0) {
                this._currentTranslateX = 0;
            }
        } else {
            this._currentTranslateX = 0;
        }

        this._elements.$stickyBarItemsWrapper.css("transform", `translate(${this._currentTranslateX}px)`);
        this._updateArrows();
    }

    _updateArrows() {
        let left = $(document).width() - 30;

        if (left > 1270) {
            left = 1270;
        }

        const max = this._elements.$stickyBarItems.width() - left;
        if (this._currentTranslateX === 0) {
            this._elements.$arrowRight.removeClass(config.classNames.arrowRightVisible);
            this._elements.$arrowLeft.addClass(config.classNames.arrowLeftVisible);
            // this._elements.$arrowLeft.attr("tabindex", "-1");
            // this._elements.$arrowRight.attr("tabindex", "0");
        } else if (this._currentTranslateX >= max) {
            this._elements.$arrowRight.addClass(config.classNames.arrowRightVisible);
            this._elements.$arrowLeft.removeClass(config.classNames.arrowLeftVisible);
            // this._elements.$arrowLeft.attr("tabindex", "0");
            // this._elements.$arrowRight.attr("tabindex", "-1");
        } else {
            this._elements.$arrowRight.addClass(config.classNames.arrowRightVisible);
            this._elements.$arrowLeft.addClass(config.classNames.arrowLeftVisible);
            // this._elements.$arrowLeft.attr("tabindex", "0");
            // this._elements.$arrowRight.attr("tabindex", "0");
        }
    }

    _becomeSticky() {
        if (!StickySection._canBecomeSticky) return;

        this._isSticky = true;
        this._elements.$stickyBar.addClass(config.classNames.stickySectionBarSticky);
        this._elements.$stickyBar.css('position', 'fixed');


        this._elements.$stickyBar.css('top', 0);
        // ParalaxSection.setCanTransform(false);

    }

    _becomeUnsticky(top) {
        this._isSticky = false;
        this._elements.$stickyBar.removeClass(config.classNames.stickySectionBarSticky);
        this._elements.$stickyBar.css('position', 'absolute');
        this._elements.$stickyBar.css('top', top);
        // ParalaxSection.setCanTransform(true);
    }

    _createStickyBarItemHtml() {
        let html = '';
        let defaultActive = 0;
        if (this._elements.$stickyBarItems[0].attributes.defaultActive !== undefined) {
            defaultActive = Number(this._elements.$stickyBarItems[0].attributes.defaultActive.value);
        }

        this._elements.$stickySectionContent.each((i, el) => {
            const $el = $(el);
            const id = $el.data(config.dataAttributes.stickySectionId);
            const title = $el.data(config.dataAttributes.stickySectionTitle);

            const active = i === defaultActive ? ` ${config.classNames.stickyBarItemActive}` : '';
            const tabindex =  i === defaultActive ? '0' : '-1'

            html += `
                <li class="sticky-section__bar-item${active}" data-sticky-section-id="${id}"  data-hover="true">
                    <span tabindex="${tabindex}"  data-index="${i}">
                        ${title}
                    </span>
                </li>
            `;
        });

        return html;
    }

    static setCanBecomneSticky(bool) {
        StickySection._canBecomeSticky = bool;
    }

    checkSticky() {
        // console.log(this._isSticky, $('.navigation').hasClass('navigation--scrollup'))
        // if(this._isSticky && $('.navigation--scrollup')){
        //     this._elements.$stickyBar.css('top', '110px');
        // }
    }

    _findFirstColoredChild(element) {
        // Überprüfen, ob das aktuelle Element eine Hintergrundfarbe hat
        const bgColor = window.getComputedStyle(element).getPropertyValue('background-color');
        const isColored = bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent';

        if (isColored) {
            // Wenn das aktuelle Element eine Hintergrundfarbe hat, geben Sie es zurück
            return element;
        } else {
            // Durchlaufen Sie alle Kindknoten und rufen Sie die Funktion rekursiv auf
            for (let i = 0; i < element.children.length; i++) {
                if (i === 0) {
                    const coloredChild = this._findFirstColoredChild(element.children[i]);

                    if (coloredChild) {
                        // Wenn ein gefärbtes Kind gefunden wurde, geben Sie es zurück
                        return coloredChild;
                    }
                }

            }
        }

        // Wenn kein gefärbtes Kind gefunden wurde, geben Sie null zurück
        return null;
    }

    _updateUrl(id) {
        history.pushState({}, "", `${window.location.pathname}?section=${encodeURIComponent(id)}`);
    }
}

moduleRegistry.registerModule('StickySection', StickySection);
moduleRegistry.autoApplyModule('StickySection', config.selectors.root);
